export default __webpack_public_path__ + "static/B0009-1df1239c1f7d803e1dd31d21bfda4bc2.png";